import { render, staticRenderFns } from "./pkd-select.vue?vue&type=template&id=27dc6450"
import script from "./pkd-select.vue?vue&type=script&lang=js"
export * from "./pkd-select.vue?vue&type=script&lang=js"
import style0 from "./pkd-select.vue?vue&type=style&index=0&id=27dc6450&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports